module.exports = __webpack_public_path__ + "assets/videos/video-banner.mp4?v=9ed81061";